export default {
  "content": "<path fill=\"#333\" fill-rule=\"evenodd\" d=\"M9.99 0C4.47 0 0 4.48 0 10s4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0zM10 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM9.72 5h.06c.4 0 .72.32.72.72v4.54l3.87 2.3c.35.2.46.65.25.99-.2.34-.64.44-.98.24L9.49 11.3a.99.99 0 01-.49-.86V5.72c0-.4.32-.72.72-.72z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 20 20"
  }
};